import { gql } from '@apollo/client';

export const ExtendSelfExclusionMutation = gql`
  mutation ExtendSelfExclusion($dateUntil: String!, $password: String!) {
    extendSelfExclusion(input: { dateUntil: $dateUntil, password: $password }) {
      errCode
      errDesc
      timeFrom
      extentionTimeUntil
    }
  }
`;
